/* eslint-disable */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {BaseHttpService, ResourceHelper} from '../../util/http-services';
import {ResourceQueryResult} from '../../util/services';
import {EmptyMessage, IdentityMessage} from '../../util/messages';
import {CustomStatisticsResource} from "../../custom-statistics/custom-statistics-resource";

/* eslint-enable */

@Injectable()
export class TaskCustomStatisticsResourceService extends BaseHttpService {

  // <editor-fold desc="CRUD">

  query(request: TaskCustomStatisticsResource.QueryRequest): Observable<ResourceQueryResult<CustomStatisticsResource.CustomStatistics>> {
    return this.http.get<ResourceQueryResult<CustomStatisticsResource.CustomStatistics>>(`${this.url}/${request.task_id}/custom-stats`, this.parseParams(request));
  }

  get(request: TaskCustomStatisticsResource.GetRequest): Observable<CustomStatisticsResource.CustomStatistics> {
    return this.http.get<CustomStatisticsResource.CustomStatistics>(`${this.url}/${request.task_id}/custom-stats/${request.id}`, this.parseParams(request));
  }

  getResults(request: TaskCustomStatisticsResource.GetResultRequest): Observable<CustomStatisticsResource.CustomStatisticsResult> {
    return this.http.get<CustomStatisticsResource.CustomStatisticsResult>(`${this.url}/${request.task_id}/custom-stats/${request.id}/result`, this.parseParams(request));
  }

  create(request: TaskCustomStatisticsResource.TaskCustomStatisticsCreateRequest): Observable<IdentityMessage> {
    return this.http.post<IdentityMessage>(`${this.url}/${request.task_id}/custom-stats`, request);
  }

  update(request: TaskCustomStatisticsResource.TaskCustomStatisticsUpdateRequest): Observable<IdentityMessage> {
    return this.http.put<IdentityMessage>(`${this.url}/${request.task_id}/custom-stats/${request.id}`, request);
  }

  delete(request: TaskCustomStatisticsResource.GetRequest): Observable<EmptyMessage> {
    return this.http.delete<EmptyMessage>(`${this.url}/${request.task_id}/custom-stats/${request.id}`);
  }

  // </editor-fold>

  constructor(private http: HttpClient, resourceHelper: ResourceHelper) {
    super(resourceHelper, '/tasks/');
  }

}

export namespace TaskCustomStatisticsResource {

  // <editor-fold desc="CRUD">

  export interface QueryRequest extends CustomStatisticsResource.QueryRequest {
    task_id: number;
  }

  export interface GetRequest extends CustomStatisticsResource.GetRequest {
    task_id: number;
  }

  export interface GetResultRequest extends CustomStatisticsResource.GetResultRequest {
    task_id: number;
  }

  export interface TaskCustomStatisticsCreateRequest extends CustomStatisticsResource.CustomStatisticsCreateRequest {
    task_id;
  }

  export interface TaskCustomStatisticsUpdateRequest extends CustomStatisticsResource.CustomStatisticsUpdateRequest {
    task_id;
  }
}
